import React from "react";
import { Typography, Button, TextField, MenuItem } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import API from "../API";

const POSITION_LABELS = {
  "dijital-satis": "Dijital Satis",
};

const HOME_OFFICE_LABELS = {
  evet: "Evet",
  hayir: "Hayir",
};

const WORK_TYPE_LABELS = {
  herikisi: "Hibrit",
};

const STATUS_LABELS = {
  received: "Alindi",
  under_review: "Incelemede",
  interview: "Mulakat",
  offer: "Teklif",
  hired: "Ise Alindi",
  rejected: "Reddedildi",
  withdrawn: "Geri Cekildi",
  on_hold: "Beklemede",
};

export default class CareerApplicationsScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      rows: [],
      page: 0,
      pageSize: 20,
      total: 0,
      filters: {
        search: "",
        city: "",
        position: "",
        workType: "",
        status: "",
      },
      draftFilters: {
        search: "",
        city: "",
        position: "",
        workType: "",
        status: "",
      },
    };
  }

  componentDidMount() {
    this.getApplications();
  }

  getApplications(page = this.state.page, pageSize = this.state.pageSize) {
    this.setState({ loading: true });

    const { filters } = this.state;
    API.fetch("careers/application", {
      page: page + 1,
      limit: pageSize,
      ...(filters.search.trim() ? { search: filters.search.trim() } : {}),
      ...(filters.city ? { city: filters.city } : {}),
      ...(filters.position ? { position: filters.position } : {}),
      ...(filters.workType ? { workType: filters.workType } : {}),
      ...(filters.status ? { status: filters.status } : {}),
    }).then((response) => {
      if (response?.error || response?.success === false) {
        this.setState({
          loading: false,
          rows: [],
          total: 0,
        });
        return;
      }

      const applications = Array.isArray(response?.applications)
        ? response.applications
        : Array.isArray(response)
          ? response
          : [];
      const sourceRows = applications.map((application, index) =>
        mapApplicationRow(application, index)
      );

      this.setState(
        {
          loading: false,
          rows: sourceRows,
          page: (response?.pagination?.page || page + 1) - 1,
          pageSize: response?.pagination?.limit || pageSize,
          total: response?.pagination?.total || sourceRows.length,
        },
      );
    });
  }

  applyFilters() {
    this.setState(
      {
        page: 0,
        filters: { ...this.state.draftFilters },
      },
      () => this.getApplications(0, this.state.pageSize),
    );
  }

  resetFilters() {
    const nextFilters = {
      search: "",
      city: "",
      position: "",
      workType: "",
      status: "",
    };

    this.setState({
      page: 0,
      filters: nextFilters,
      draftFilters: nextFilters,
    }, () => this.getApplications(0, this.state.pageSize));
  }

  render() {
    const { draftFilters } = this.state;
    const cityOptions = [
      "Ankara",
      "Aydın",
      "Bursa",
      "Diğer",
      "İstanbul",
      "İzmir",
      "Kocaeli",
      "Muğla",
      "Sakarya",
    ];
    const positionOptions = ["dijital-satis", "operasyon", "surucu-kazanim"];
    const workTypeOptions = ["parttime", "fulltime", "herikisi"];
    const statusOptions = [
      "received",
      "under_review",
      "interview",
      "offer",
      "hired",
      "rejected",
      "withdrawn",
      "on_hold",
    ];

    return (
      <Badge style={{ marginTop: 24, padding: 0, overflow: "hidden" }}>
        <div style={{ padding: 24, borderBottom: "1px solid #E6E8F0" }}>
          <Typography variant="h6">Kariyer Basvurulari</Typography>
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(240px, 1.4fr) repeat(4, minmax(150px, 1fr)) auto auto",
              gap: 12,
              alignItems: "center",
              marginTop: 16,
            }}
          >
            <TextField
              size="small"
              label="Arama"
              value={draftFilters.search}
              onChange={(e) =>
                this.setState({
                  draftFilters: {
                    ...draftFilters,
                    search: e.target.value,
                  },
                })
              }
            />
            <TextField
              select
              size="small"
              label="Sehir"
              value={draftFilters.city}
              onChange={(e) =>
                this.setState({
                  draftFilters: {
                    ...draftFilters,
                    city: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="">Tum Sehirler</MenuItem>
              {cityOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              size="small"
              label="Pozisyon"
              value={draftFilters.position}
              onChange={(e) =>
                this.setState({
                  draftFilters: {
                    ...draftFilters,
                    position: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="">Tum Pozisyonlar</MenuItem>
              {positionOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {getPositionLabel(option)}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              size="small"
              label="Calisma Tipi"
              value={draftFilters.workType}
              onChange={(e) =>
                this.setState({
                  draftFilters: {
                    ...draftFilters,
                    workType: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="">Tum Tipler</MenuItem>
              {workTypeOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {getWorkTypeLabel(option)}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              size="small"
              label="Durum"
              value={draftFilters.status}
              onChange={(e) =>
                this.setState({
                  draftFilters: {
                    ...draftFilters,
                    status: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="">Tum Durumlar</MenuItem>
              {statusOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {getStatusLabel(option)}
                </MenuItem>
              ))}
            </TextField>
            <Button variant="contained" onClick={() => this.applyFilters()}>
              Filtrele
            </Button>
            <Button variant="outlined" onClick={() => this.resetFilters()}>
              Temizle
            </Button>
          </div>
        </div>
        <DataGrid
          autoHeight
          disableSelectionOnClick
          loading={this.state.loading}
          rows={this.state.rows}
          paginationMode="server"
          rowCount={this.state.total}
          paginationModel={{
            page: this.state.page,
            pageSize: this.state.pageSize,
          }}
          onPaginationModelChange={(model) => {
            this.getApplications(model.page, model.pageSize);
          }}
          pageSizeOptions={[20, 50, 100]}
          sortingOrder={["desc", "asc"]}
          initialState={{
            sorting: {
              sortModel: [{ field: "createdAt", sort: "desc" }],
            },
          }}
          columns={[
            {
              field: "fullName",
              headerName: "AD SOYAD",
              flex: 1.2,
              minWidth: 180,
              renderCell: (params) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="body1">{params.row.fullName}</Typography>
                  <Typography variant="body2">{params.row.email}</Typography>
                </div>
              ),
            },
            {
              field: "phone",
              headerName: "TELEFON",
              flex: 1,
              minWidth: 150,
            },
            {
              field: "city",
              headerName: "SEHIR",
              flex: 0.9,
              minWidth: 130,
            },
            {
              field: "position",
              headerName: "POZISYON",
              flex: 1,
              minWidth: 150,
            },
            {
              field: "workType",
              headerName: "CALISMA TIPI",
              flex: 1,
              minWidth: 150,
            },
            {
              field: "status",
              headerName: "DURUM",
              flex: 0.8,
              minWidth: 120,
              renderCell: (params) => params.row.statusLabel,
            },
            {
              field: "createdAt",
              headerName: "TARIH",
              flex: 1,
              minWidth: 170,
              renderCell: (params) => params.row.createdAtLabel,
              sortComparator: (v1, v2) => v1 - v2,
            },
            {
              field: "actions",
              headerName: " ",
              sortable: false,
              filterable: false,
              width: 90,
              renderCell: (params) => (
                <a
                  href={
                    "../careers/" +
                    (params.row.application.applicationId || params.row.id)
                  }
                >
                  <Button>
                    <ArrowForwardIcon />
                  </Button>
                </a>
              ),
            },
          ]}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#F3F4F6",
              borderRadius: 0,
            },
          }}
        />
      </Badge>
    );
  }
}

function mapApplicationRow(application, index) {
  return {
    id: application._id || application.applicationId || index,
    application,
    fullName:
      [application.firstName, application.lastName]
        .filter(Boolean)
        .join(" ")
        .trim() || "-",
    email: application.email || "-",
    phone: application.phone || "-",
    city: application.city || "-",
    position: getPositionLabel(application.position),
    workType: getWorkTypeLabel(application.workType),
    status: application.status || "",
    statusLabel: getStatusLabel(application.status),
    createdAt: getCreatedAt(application),
    createdAtLabel: getCreatedAtLabel(application),
  };
}

function getPositionLabel(position) {
  if (!position) return "-";
  return POSITION_LABELS[position] || position;
}

function getWorkTypeLabel(workType) {
  if (!workType) return "-";
  return WORK_TYPE_LABELS[workType] || workType;
}

function getStatusLabel(status) {
  if (!status) return "-";
  return STATUS_LABELS[status] || status;
}

function getCreatedAt(application) {
  if (!application?._id) return 0;
  return new Date(parseInt(application._id.substring(0, 8), 16) * 1000).getTime();
}

function getCreatedAtLabel(application) {
  const createdAt = getCreatedAt(application);
  if (!createdAt) return "-";
  return new Date(createdAt).toLocaleString("tr-TR");
}

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        boxShadow:
          "rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px",
        borderRadius: 8,
        padding: 24,
        color: "rgb(18, 24, 40)",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
